document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.section-tabs__tab');
    const tabsContent = document.querySelectorAll('.section-tabs__tab-content');

    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            tabsContent.forEach(tabContent => tabContent.classList.remove('active'));
            document.getElementById(tab.getAttribute('data-section-tab')).classList.add('active');
        });
    });

    let interval  = setInterval(() => {
        const qaTabContent = document.querySelector('#tab3 .jdgm-subtab__name[data-tabname="questions"]')
        if (qaTabContent) {
            qaTabContent.click();
            clearInterval(interval);
        }
    }, 500);
});

document.querySelector('body').addEventListener('click', function(event) {
    const sectionReviews = document.querySelector('#tab2 .jdgm-rev-widg__header');
    const sectionReviewsButtonClicked = event.target.classList.contains('section-reviews__mobile-filter')
        || event.target.classList.contains('icon-filter-sort')
        || event.target.classList.contains('section-reviews__mobile-filter-text');

    if (sectionReviews) {
        if (sectionReviewsButtonClicked) {
            sectionReviews.classList.toggle('active');
        } else {
            sectionReviews.classList.remove('active');
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".section-tabs__tab-specs-content a").forEach(function (link) {
        link.addEventListener("click", function (event) {
            let href = link.getAttribute("href");
            if (href && (href.startsWith("https") || href.startsWith("www"))) {
                return;
            }
            if (href && !href.startsWith("/")) {
                event.preventDefault();
                window.location.href = "/" + href;
            }
        });
    });
});